import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Icon } from '../ui';
import { useVerlaufMerken, useScrollstandMerken } from '../ZurueckLink';
import { useFriedhof } from '../../contexts/FriedhofContext';
import FriedhofAuswahl from '../../pages/FriedhofAuswahl';
import './Layout.css';

const LEISTE_KEY = 'tfp.seitenleiste';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Ab Tablet-Breite standardmäßig ausgeklappt, außer der Nutzer hat eingeklappt (gemerkt);
  // auf dem Handy immer zu – dort ist die Leiste ein Overlay.
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined' || window.innerWidth < 769) return false;
    try { return localStorage.getItem(LEISTE_KEY) !== 'eingeklappt'; } catch { return true; }
  });
  const { isFriedhofSelected } = useFriedhof();

  // Toggling the sidebar changes the content width; tell Leaflet (and others) to re-measure
  // after the CSS transition so the map fills the new space correctly.
  const toggleSidebar = () => {
    setSidebarOpen(o => {
      if (window.innerWidth >= 769) {
        try { localStorage.setItem(LEISTE_KEY, o ? 'eingeklappt' : 'offen'); } catch { /* egal */ }
      }
      return !o;
    });
    window.setTimeout(() => window.dispatchEvent(new Event('resize')), 320);
  };

  useVerlaufMerken();
  useScrollstandMerken();

  // After login the user must pick a Friedhof before any management screen is shown.
  if (!isFriedhofSelected) {
    return <FriedhofAuswahl />;
  }

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onToggle={toggleSidebar} />
      {/* Handy: die Leiste ist ein Overlay – dieser Knopf öffnet sie. Ab Tablet-Breite ist sie immer
          da (ein- oder ausgeklappt), eine Kopfzeile braucht es nicht. */}
      {!sidebarOpen && (
        <button className="menue-knopf" onClick={toggleSidebar} aria-label="Menü öffnen">
          <Icon.Menue className="h-5 w-5" />
        </button>
      )}
      <div className={`main-content ${sidebarOpen ? 'with-sidebar' : ''}`}>
        <main className="main-body">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
